import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationAccountSetOidcSubjectTemplateArgs } from "types/generated";

type OidcSubjectTemplateData = {
  oidcSubjectTemplate: string | null;
};

export const GET_OIDC_SUBJECT_TEMPLATE: TypedDocumentNode<OidcSubjectTemplateData> = gql`
  query GetOidcSubjectTemplate {
    oidcSubjectTemplate
  }
`;

type SetOidcSubjectTemplateData = {
  accountSetOIDCSubjectTemplate: string | null;
};

export const SET_OIDC_SUBJECT_TEMPLATE: TypedDocumentNode<
  SetOidcSubjectTemplateData,
  MutationAccountSetOidcSubjectTemplateArgs
> = gql`
  mutation SetOidcSubjectTemplate($template: String) {
    accountSetOIDCSubjectTemplate(template: $template)
  }
`;
